import { FC, ReactNode } from "react";
import styles from "./BlockHistory.module.scss";
import { IBlockHistoryItem, IUser } from "@/entities/users/types";
import { Button, Title, UserAvatar } from "@/shared";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import clsx from "clsx";
import { useDrawer } from "@/app/providers/DrawerProvider/useDrawer";

dayjs.extend(utc);
dayjs.extend(timezone);

function getUserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

interface BlockHistoryProps {
  user: IUser;
  blockHistory: IBlockHistoryItem[];
}

const BlockHistory: FC<BlockHistoryProps> = ({ user, blockHistory }) => {
  const { closeDrawer } = useDrawer();

  const namesToUse: (keyof IBlockHistoryItem)[] = [
    "blockedAt",
    "blockedByUsername",
    "blockComments",
    "unblockedAt",
    "unblockedByUsername",
    "unblockComments",
  ];

  const itemNames: Partial<Record<keyof IBlockHistoryItem, string>> = {
    blockedAt: "Дата блокировки",
    blockedByUsername: "Ответственный",
    unblockedAt: "Дата снятия блокировки",
    unblockedByUsername: "Ответственный",
    blockComments: "Комментарий",
    unblockComments: "Комментарий",
  };
  const getTime = (value: string) => {
    const timeZone = getUserTimeZone();
    const time = dayjs.utc(value).tz(timeZone).format("DD.MM.YYYY HH:mm");
    return time;
  };
  const getValue = (
    item: keyof IBlockHistoryItem,
    history: IBlockHistoryItem,
  ) => {
    let val: string | ReactNode = history[item];
    if (item === "blockedAt" || item === "unblockedAt") {
      val = history[item] ? getTime(history[item]) : "—";
    }
    if (item === "blockedByUsername" || item === "unblockedByUsername") {
      val = (
        <div className={clsx(styles.title, styles.noPaddings)}>
          <UserAvatar fio={history[item]} image={null} small />
          {history[item]}
        </div>
      );
    }
    return val;
  };

  return (
    <div className={styles.historyWrapper}>
      <Title text="История блокировки" type="default" />
      <div className={styles.title}>
        <UserAvatar fio={user.fio} image={user.image} small />
        {user.fio}
      </div>
      <div className={styles.info}>
        {blockHistory.length > 0 ? (
          blockHistory.map((history) => (
            <div key={history.id} className={styles.infoItemWrapper}>
              {namesToUse.map((item) => (
                <>
                  <div key={item} className={styles.infoItem}>
                    <span className={styles.left}>{itemNames[item]}:</span>
                    <span className={styles.right}>
                      {getValue(item, history) || "—"}
                    </span>
                  </div>
                  {item === "blockComments" && <br />}
                </>
              ))}
            </div>
          ))
        ) : (
          <div>Нет данных</div>
        )}
        <div className={styles.actionButtons}>
          <Button
            buttontStyle="cancelBtn"
            name="Закрыть"
            onClick={closeDrawer}
          />
        </div>
      </div>
    </div>
  );
};

export default BlockHistory;
